import React, { useState, useEffect, useRef } from 'react';
import './ProductCatalogSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const ProductCatalogSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  // Lista de imágenes del sistema (deberás agregarlas en la carpeta public/img/)
  const catalogImages = [
    {
      src: '/img/catalogo1.png',
      alt: 'Vista General del Catálogo',
      title: 'Vista General del Catálogo'
    },
    {
      src: '/img/catalogo2.png',
      alt: 'Detalle de Producto',
      title: 'Detalle Detallado del Producto'
    }
  ];

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % catalogImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + catalogImages.length) % catalogImages.length);
  };

  return (
    <div className="product-catalog-section" ref={sectionRef}>
      <h2 className="section-title">Catálogo de Productos en Acción</h2>
      <p className="section-subtitle">Conoce cómo funciona la gestión de catálogo en nuestro sistema</p>
      
      <div className={`catalog-gallery ${isVisible ? 'animate__animated animate__fadeIn' : ''}`}>
        <div className="gallery-container">
          <div className="image-wrapper">
            <img 
              src={catalogImages[currentImageIndex].src} 
              alt={catalogImages[currentImageIndex].alt}
              className="catalog-image"
              onError={(e) => {
                e.target.src = '/img/placeholder-catalog.png';
              }}
            />
          </div>
          
          <button className="nav-button prev" onClick={prevImage}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <button className="nav-button next" onClick={nextImage}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>

        <div className="image-info">
          <h3>{catalogImages[currentImageIndex].title}</h3>
          <p>{catalogImages[currentImageIndex].alt}</p>
        </div>

        <div className="image-indicators">
          {catalogImages.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
              aria-label={`Ver imagen ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <div className="catalog-info">
        <div className="info-card">
          <h4>✨ Características</h4>
          <p>Búsqueda por nombre, filtros por categoría, ordenamiento por precio y visualización de stock en tiempo real.</p>
        </div>
        <div className="info-card">
          <h4>🚀 Rendimiento</h4>
          <p>Carga rápida de imágenes, navegación fluida y experiencia optimizada en todos los dispositivos.</p>
        </div>
      </div>
    </div>
  );
};

export default ProductCatalogSection;
